export interface RigAssessment {
  id?: string;
  rigName?: string;
  RigName?: string;
  location?: string;
  Location?: string;
  runDate?: string;
  RunDate?: string;
  phase?: string;
  Phase?: string;
  reason?: string;
  Reason?: string;
  possiblePlugging?: string;
  PossiblePlugging?: string;
  reasonPlugging?: string;
  ReasonPlugging?: string;
  prompt?: string;
  Prompt?: string;
  contextSample?: string;
  ContextSample?: string;
}

export const getAssessmentField = (a: RigAssessment | undefined | null, key: keyof RigAssessment): string => {
  if (!a) return '';
  const direct = (a as any)[key];
  if (direct !== undefined && direct !== null) return String(direct);
  const altKey = (key.charAt(0).toUpperCase() + key.slice(1)) as keyof RigAssessment;
  const alt = (a as any)[altKey];
  if (alt !== undefined && alt !== null) return String(alt);
  return '';
};
